import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class DistrictResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.district).get(options);
  }

  get(id) {
    return this.$resource(apis.district + id).get();
  }

  search(query = "", params) {
    return this.$resource(apis.district + "autocomplete/").get(
      assign(params, { query })
    );
  }

  find(options) {
    return this.$resource(apis.district + "find/").get(options);
  }

  post(item) {
    return this.$resource(apis.district).save(item);
  }

  update(id, item) {
    return this.$resource(apis.district + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.district + id + `/${name}`).save(item);
  }
}

export default DistrictResource;



// WEBPACK FOOTER //
// ./src/resources/district/district.resource.js